import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b0b24cc2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b0b24cc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b24cc2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType3: require('D:/Project/kpwebsite/PC/components/content/content-type-3.vue').default})
